import React from  'react';
import '../CSS/HeroSection.css';
import Book from '../Images/bookCover.png';
import Likit from  '../Images/Likhit.png';
import Book2 from  '../Images/Book2.png';

const HeroSection = () =>{

  return (
   


<div className='Aboutus-HeroSection'>
<h4 className='bhasha'>भाषेचा प्रचार</h4>
<img src={Likit} alt="Likit" className='Likhit-img'></img>

<div className='middle-cont'>
<h2 className='sahitya'><span>साहित्याच</span> सादरीकरण  </h2>

<img src={Book2} alt='page-book' className='book-pages'></img>

</div>

<img src={Book} alt="Books" className='Books-bunch'></img>
<p className='sanskruti'> <span> संस्कृतीची </span> जोपासना</p>


</div>
  )


}

export default HeroSection;